import { render, staticRenderFns } from "./OrderChange.vue?vue&type=template&id=d6efc0a8&scoped=true&"
import script from "./OrderChange.vue?vue&type=script&lang=js&"
export * from "./OrderChange.vue?vue&type=script&lang=js&"
import style0 from "./OrderChange.vue?vue&type=style&index=0&id=d6efc0a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6efc0a8",
  null
  
)

export default component.exports